import { Component, HostListener, Input, OnChanges, OnInit, Output, EventEmitter } from '@angular/core';
import { ApiHttpService } from 'src/app/core/services/apiHttpcall.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MessageService } from 'primeng/api';

export interface TripAction {
  id: number;
  name: string;
  status: string;
  completed_at: string | null;
  attachments: any[]; // Add attachments array
  show_pod_button: number; // Add show_pod_button field
  date?: string;
  has_pod?: boolean;
  manual_completed_at?: string|null;
}

export interface TripActionsData {
  trip_id: number;
  pickup_at: string;
  delivered_at: string;
  actual_pickup_datetime?: string;  // Add optional actual dates
  actual_delivery_datetime?: string;
  actions: TripAction[];
}

export interface TimelineActionData extends TripAction {
  actionNumber: number;
  showPod: boolean;
  date: string;
  isCompleted: boolean; // Add this property
}

@Component({
  selector: 'actions-sidebar',
  templateUrl: './actions-sidebar.component.html',
  styleUrls: ['./actions-sidebar.component.scss']
})
export class ActionsSidebarComponent implements OnInit, OnChanges {
  @Input() tripActionsData: TripActionsData | null = null;
  @Input() isVisible: boolean = false;

  @Output() onHide = new EventEmitter<void>();
  @Output() onViewPod = new EventEmitter<TripAction>();

  @HostListener('document:keydown.escape', ['$event'])
  onEscPressed(event: KeyboardEvent) {
    this.hide();
  }

  actions: TripAction[] = [];
  timelineData: TimelineActionData[] = [];

  constructor() { }

  ngOnInit() {
    this.updateActions();
  }

  ngOnChanges() {
    this.updateActions();
  }

  private updateActions() {
    if (this.tripActionsData?.actions) {
      this.actions = this.tripActionsData.actions;

      this.timelineData = this.actions.map((action, index) => ({
        ...action,
        actionNumber: this.actions.length - index,
        showPod: this.shouldShowPod(action),
        date :action.manual_completed_at ?? action.completed_at,
        isCompleted: action.status.toLowerCase() === 'completed' // Add completion check
      }));

      console.log('Timeline data:', this.timelineData);
    } else {
      this.actions = [];
      this.timelineData = [];
    }
  }

  show() {
  }

  hide() {
    this.onHide.emit();
  }

  onPodClick(action: TripAction) {
    console.log('POD clicked for action:', action);
    this.onViewPod.emit(action);
  }

  shouldShowPod(action: TripAction): boolean {
    return action.show_pod_button === 1;
  }

  disableSorting() {
    return 0;
  }
}
